<template>
  <div class="profile">
    <div class="setting-btn" @click="$router.push('/setting')"></div>
    <div class="header">
      <div :class="['avatar-box', { 'vip': userInfo.is_vip }]">
        <img class="vipavatar" src="@/assets/images/icon/vip.png" alt="" />
        <img class="avatar" src="" @error="setDefaultAvatar" alt="" />
      </div>
      <span>{{ userInfo.nickname || '' }}</span>
    </div>
    <img class="ads" src="@/assets/images/bg/premium-banner.png" alt="" @click="handleClickAds" />
    <div class="column">
      <div class="column-item">
        <span class="title" @click="handleClickRewards">Daily Quests</span>
        <span>First 7 Days</span>
      </div>
      <div class="column-item" @click="$router.push('/topup');">
        <span class="title">Wallet</span>
        <span>Top Up Gems</span>
      </div>
    </div>
    <div class="tools">
      <div class="tools-item" v-for="item in toolList" :key="item.icon" @click="handleClick(item)">
        <img :src="require(`@/assets/images/icon/${item.icon}.png`)" alt="" />
        <span>{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import defaultAvatarImage from '@/assets/images/icon/avatar.png';

export default {
  components: {
  },
  data() {
    return {
      toolList: [
        { title: 'Feedback', icon: 'feedback', email: 'support@tap-vibes.com' },
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.userInfo.email) {
        this.$login();
      }
    },
    setDefaultAvatar(e) {
      e.target.src = defaultAvatarImage;
    },
    handleClick(item) {
      // if (!item.path) return;
      // this.$router.push(item.path);
      if (item.title === 'Feedback') {
        const link = `mailto:${item.email}?body=${encodeURIComponent(`User ID: ${this.userInfo.id} (Do Not Remove)`)}`;
        window.location.href = link;
      }
    },
    handleClickAds() {
      this.$router.push('/premium');
    },
    handleClickRewards() {
      this.$promt({ type: 'rewards' });
    },
  },
};
</script>

<style lang="less" scoped>
.profile {
  background-image: linear-gradient(#adf4cc 0%, #e4fce5 90px, #fff 200px);
  height: 100%;
  padding: 10px 16px;
  .setting-btn {
    width: 24px;
    height: 24px;
    background: url('~@/assets/images/icon/setting-black.png') center no-repeat;
    background-size: 100%;
    margin-left: auto;
  }
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    .avatar-box {
      width: 80px;
      height: 80px;
      border-radius: 80px;
      margin-bottom: 12px;
      position: relative;
      img {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
        &.avatar {
          width: 70px;
          height: 70px;
          left: 5px;
          z-index: 1;
        }
        &.vipavatar {
          display: none;
        }
      }
      &.vip {
        img{
          &.vipavatar {
            display: block;
          }
        }
      }
    }
    span {
      font-size: 24px;
    }
  }
  .ads {
    width: 100%;
    margin: 16px 0;
  }
  .column {
    display: flex;
    justify-content: space-between;
    .column-item {
      padding: 12.5px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: linear-gradient(99.99deg, #EDFAF5 28.19%, #E7FBF7 94.41%);
      border-radius: 12px;
      width: 160px;
      color: @gray;
      font-size: @fontMedium;
      .title {
        font-size: @fontLarge;
        color: @black;
      }
    }
  }
  .tools {
    margin-top: 16px;
    .tools-item {
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 56px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
      &::after {
        content: '';
        width: 24px;
        height: 24px;
        background: url('~@/assets/images/icon/arrow.png') no-repeat center;
        background-size: 24px;
        margin-left: auto;
      }
    }
  }
}
</style>
